"use strict";

exports.__esModule = true;
exports.getPlantActivity = getPlantActivity;
exports.getPlantActivityList = getPlantActivityList;
exports.getPlantActivityOrThrow = getPlantActivityOrThrow;
var _Utils = require("../../Utils");
/**
 * Get the plant activity with the given id
 * from an array of plant activities.
 * If no corresponding activity exists a temporary one will be created.
 */
function getPlantActivity(activities, id) {
  for (var i = 0; i < activities.length; i++) {
    var item = activities[i];
    if (item.id === id) {
      return item;
    }
  }
  return {
    id: id,
    name: (0, _Utils.humanizeString)(decodeURIComponent(id)),
    description: "",
    show: false
  };
}

/**
 * Get the plant activity with the given id
 * from an array of plant activities.
 * If no corresponding activity exists a temporary one will be created.
 */
function getPlantActivityList(activities, id) {
  for (var i = 0; i < activities.length; i++) {
    var item = activities[i];
    if (item.id === id) {
      return item;
    }
  }
  return {
    id: id,
    name: (0, _Utils.humanizeString)(id),
    description: "",
    show: false
  };
}

/**
 * Get the plant activity with the given id
 * from an array of plant activities.
 * @throws {Error} if no such activity exists.
 */
function getPlantActivityOrThrow(activities, id) {
  for (var i = 0; i < activities.length; i++) {
    var item = activities[i];
    if (item.id === id) {
      return item;
    }
  }
  throw new Error("Could not find a PlantActivity with id: " + decodeURIComponent(id));
}